import apiClient from "../utils/axiosConfig";
import { getApiUrl, API_ENDPOINTS } from "../Configurations/config";
import { normalizeExecutiveFocusNote } from "./executiveFocusNoteAnalytics";

const EXECUTIVE_FOCUS_NOTE_TIMEOUT_MS = 300000;

const compactFilters = (filters = {}) =>
  Object.fromEntries(
    Object.entries({
      yearmonth: filters.yearmonth,
      fiscal_year: filters.fiscalYear || filters.fiscal_year,
      division: filters.division,
      state: filters.state,
      hq: filters.hq,
      territory: filters.territory,
      brand: filters.brand,
      employee_id: filters.employeeId || filters.employee_id,
      bdm: filters.bdm,
      zm: filters.zm,
    }).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );

export async function generateExecutiveFocusNote({ mode, filters }, options = {}) {
  const requestFilters = compactFilters(filters);
  const response = await apiClient.post(
    getApiUrl(API_ENDPOINTS.EXECUTIVE_FOCUS_NOTE.GENERATE),
    {
      mode,
      filters: requestFilters,
    },
    {
      signal: options.signal,
      timeout: EXECUTIVE_FOCUS_NOTE_TIMEOUT_MS,
    }
  );

  return normalizeExecutiveFocusNote(response.data, filters || requestFilters, mode);
}

